import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import KanbanCard from './KanbanCard';
import './KanbanColumn.css';

function KanbanColumn({ id, title, color, orders, count, onStatusChange, onCardClick, onCancelOrder, isDelivered, userRole }) {
  const { setNodeRef, isOver } = useDroppable({
    id: id,
  });

  const orderIds = orders.map((order) => order.orderId);

  return (
    <div
      className={`kanban-column ${isDelivered ? 'kanban-column-delivered' : ''} ${isOver ? 'kanban-column-over' : ''}`}
    >
      <div className="kanban-column-header" style={{ borderBottomColor: color }}>
        <div className="kanban-column-title">
          <span className="kanban-column-dot" style={{ backgroundColor: color }} />
          <span>{title}</span>
        </div>
        <span className="kanban-column-count" style={{ backgroundColor: color }}>
          {count}
        </span>
      </div>

      <SortableContext items={orderIds} strategy={verticalListSortingStrategy}>
        <div ref={setNodeRef} className="kanban-column-content">
          {orders.length === 0 ? (
            <div className="kanban-column-empty">
              <span className="material-icons" aria-hidden="true">inbox</span>
            </div>
          ) : (
            orders.map((order) => (
              <KanbanCard
                key={order.orderId}
                order={order}
                onStatusChange={onStatusChange}
                onCardClick={onCardClick}
                onCancelOrder={onCancelOrder}
                isCompact={isDelivered}
                userRole={userRole}
              />
            ))
          )}
        </div>
      </SortableContext>
    </div>
  );
}

export default KanbanColumn;
